import { extendObservable, toJS } from 'mobx'
import find from 'lodash/find'

import { expertApi } from '@atheneum/api'

import { highligthReplace } from '@atheneum/api/dist/lib'

class HistoryStore {
  constructor (expertStore, expertSearchStore) {
    extendObservable(this, {
      projects: {
        rows: [],
        count: 0
      },
      costs: {
        rows: [],
        count: 0
      },
      loading: false,
      error: null,
      expertStore,
      perPage: 6,
      feedbacks: {},
      loadingFilters: false,
      eplStatusCount: [],
      replyStatusCount: [],
      selectedEplStatusFilters: [],
      selectedReplyStatusFilters: [],
      loadingFilteredResults: false,
      expertSearchStore
    })

    this.get(this.page || 1)
  }

  get (page, initialLoading = false) {
    if (initialLoading) this.loading = true
    else this.loadingFilteredResults = true

    if (!this.expertStore.id || !page) return null

    const limit = this.perPage
    const offset = (page - 1) * limit
    const selectedEplStatusFilters = toJS(this.selectedEplStatusFilters)
    const selectedReplyStatusFilters = toJS(this.selectedReplyStatusFilters)

    const elasticHighlights = this.expertSearchStore.getHighlightsRegexp(
      this.expertStore.id,
      true,
      true
    )

    return expertApi
      .getExpertProjects(
        this.expertStore.id,
        limit,
        offset,
        selectedEplStatusFilters,
        selectedReplyStatusFilters,
        elasticHighlights,
        this.expertSearchStore.query.includeScreeningInformation
      )
      .then(({ rows, count }) => {
        const hiReg = this.expertSearchStore.getHighlightsRegexp(
          this.expertStore.id
        )
        const projects = formatProjectsDataWithHighlights(rows, hiReg)
        this.projects.rows.replace(projects)
        this.projects.count = count
        this.loading = false
        this.loadingFilteredResults = false
      })
      .catch(err => {
        this.error = err
        this.loading = false
        this.loadingFilteredResults = false
      })
  }

  getCosts (page = 1) {
    const limit = 9
    const offset = (page - 1) * limit
    return expertApi
      .getOtherServices(this.expertStore.id, limit, offset)
      .then(({ rows, count }) => {
        this.costs.rows.replace(rows)
        this.costs.count = count
      })
      .catch(err => {
        this.error = err
      })
  }

  getFeedbacks (expertId, eplId) {
    return expertApi.getProjectFeedbacks(eplId, expertId).then(feedbacks => {
      this.feedbacks = feedbacks
    })
  }

  changePage (page, forbidUpdate) {
    this.page = page
    if (!forbidUpdate) this.get(page)
  }

  async getStatusCountFilters () {
    try {
      this.loadingFilters = true

      const eplStatusCount = await expertApi.getEplStatusCount(
        this.expertStore.id
      )
      const replyStatusCount = await expertApi.getReplyStatusCount(
        this.expertStore.id
      )

      this.eplStatusCount = eplStatusCount
      this.replyStatusCount = replyStatusCount

      this.loadingFilters = false
    } catch (err) {
      this.error = err
      this.loadingFilters = false
    }
  }

  clearSearch () {
    this.selectedEplStatusFilters.replace([])
    this.selectedReplyStatusFilters.replace([])
  }

  updateEplStatusFilters (id) {
    const selectedEplStatusFilters = toJS(this.selectedEplStatusFilters)

    const idPosition = selectedEplStatusFilters.indexOf(id)

    if (idPosition > -1) selectedEplStatusFilters.splice(idPosition, 1)
    else selectedEplStatusFilters.push(id)

    this.selectedEplStatusFilters.replace(selectedEplStatusFilters)
  }

  updateReplyStatusFilters (id) {
    const selectedReplyStatusFilters = toJS(this.selectedReplyStatusFilters)

    const idPosition = selectedReplyStatusFilters.indexOf(id)

    if (idPosition > -1) selectedReplyStatusFilters.splice(idPosition, 1)
    else selectedReplyStatusFilters.push(id)

    this.selectedReplyStatusFilters.replace(selectedReplyStatusFilters)
  }
}

function formatProjectsDataWithHighlights (projects, hiReg) {
  if (!hiReg) return projects
  const result = projects.map(proj => {
    proj.screening = highligthReplace(proj.screening, hiReg)
    proj.screeningQuestions = proj.screeningQuestions.map(sq => {
      return {
        ...sq,
        question: highligthReplace(sq.question, hiReg),
        answer: highligthReplace(sq.answer, hiReg)
      }
    })

    proj.match =
      hiReg.test(proj.screening) ||
      find(
        proj.screeningQuestions,
        sq => hiReg.test(sq.question) || hiReg.test(sq.answer)
      )

    return proj
  })

  return result
}

export default HistoryStore
